<div class="group-container" [id]="'checkbox-target-' + group.id">
  <div class="checkbox-container">
    <div class="checkbox-target">
      <markant-checkbox
        [disabled]="!group.hasSlotsAvailable"
        [checked]="checked"
        (checkedChange)="onCheckbox(group.id)"
      >
      </markant-checkbox>
      <span class="group-name">{{ group.displayName }}</span>
    </div>
  </div>

  <p class="group-cartridge">
    <span>{{ group.cartridgeVariants.length }}</span>
    {{
      'organization.users.invite.groupView.groupSelection.cartridges'
        | transloco
    }}
  </p>

  <p class="group-cartridge">
    <span>{{ group.membersCount }}</span>
    {{
      'organization.users.invite.groupView.groupSelection.members' | transloco
    }}
  </p>
</div>

@if (!group.hasSlotsAvailable) {
  <markant-tooltip
    [for]="'checkbox-target-' + group.id"
    [label]="
      'organization.users.invite.groupView.maxCapacityReached' | transloco
    "
    [trigger]="'mouseenter focus'"
    placement="right"
  >
  </markant-tooltip>
}
